import Cookies from "js-cookie"

export default (context, inject) => {
    inject('jsCookies', Cookies)
}